import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, ASC } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadProjectGroups,
    SortProjectGroups,
    setProjectGroupList,
    setProjectGroupIds,
} from "client/store"
import {
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
    Loader,
} from "client/components"

import List from "./list"
import { ContainerStyled, Title } from "../styled"

const CcApprovalLevel = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const defaultGroupsAssigned = useSelector((state: StoreType) => state.system.accountSettings.project.defaultGroupsAssigned)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const menu = [
        { key: "#formal", module: 0, title: lang.formal },
        { key: "#compliance", module: 1, title: lang.compliance },
        { key: "#review", module: 2, title: lang.review },
        { key: "#requirements", module: 3, title: lang.requirements },
    ]

    const [activeTab, setActiveTab] = useState("#formal")
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadProjectGroups(userData.accountId, project.id, project.id ? true : defaultGroupsAssigned)
        .then((res) => {
            const sortedIds = SortProjectGroups(Object.values(res), "order", ASC, {})
            dispatch(setProjectGroupIds(sortedIds))
            dispatch(setProjectGroupList(res))
            setLoadState(IDLE)
        })
    }, [project, defaultGroupsAssigned])

    return (
        <ContainerStyled>
            <Title>{lang.approvalLevels}</Title>
            <PageContent>
                <PageMenu>
                    {
                        menu.map((menuRow) => (
                            <PageMenuButton
                                key={menuRow.key}
                                isActive={activeTab === menuRow.key}
                                onClick={() => setActiveTab(menuRow.key)}
                            >
                                {menuRow.title}
                            </PageMenuButton>
                        ))
                    }
                </PageMenu>
                {
                    menu.map((menuRow) => (
                        <Tab
                            key={menuRow.key}
                            show={activeTab === menuRow.key}
                        >
                            {
                                loadState === PENDING
                                && <Loader />
                            }
                            <List module={menuRow.module} />
                        </Tab>
                    ))
                }
            </PageContent>
        </ContainerStyled>
    )
}
export default CcApprovalLevel
